import $ from 'jquery';
import AccountService from '../_shared/account-service';

export default class PremiumContent {
  constructor(premiumContentSelector) {
    this.$premiumContent = $(premiumContentSelector);

    this.init();
  }

  async init() {
    this.isInitialized = true;

    if (!this.$premiumContent.length) {
      this.isInitialized = false;

      return;
    }

    try {
      await AccountService.isAuthenticated();

      let hasSubscription;
      const userData = await AccountService.getUserData();
      if (userData) {
        hasSubscription = await AccountService.isPremiumUser(userData.id);
      }

      if (hasSubscription) {
        this.$premiumContent.addClass('is-eligible');
      } else {
        console.warn('User doesn\'t have a subscription!');
      }
    } catch (e) {
      console.error(`An error occurred during validation of user subscription: ${e}`);
    }
  }
}
